import ApiClient, {IApiClient} from "./ApiClient"
import {SuccessResponse} from "data/types/SuccessResponse"
import {IEligibilityOutcome} from "models/IEligibilityOutcome"

// Posts the eligibility outcome / lead to dtc-api-service, which holds the GHL
// credentials and forwards the write to GHL. The endpoint is created in the
// cross-repo step; until then these calls will fail and callers handle that.
const urlSubPath = "/leads"

export default class LeadApi {
  private apiClient: IApiClient

  public constructor() {
    this.apiClient = new ApiClient(process.env.REACT_APP_API_BASE_URL || "")
  }

  public submitEligibilityOutcome = async (
    req: IEligibilityOutcome
  ): Promise<void> => {
    await this.apiClient.post<IEligibilityOutcome, SuccessResponse>(
      `${urlSubPath}`,
      req
    )
    return
  }
}
